export default __webpack_public_path__ + "static/media/pdf_thumbnail.0b806ea6.jpg";